//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class DaySelectionDisplayItem extends ItemBase {
    Sunday: boolean = false;
    Monday: boolean = false;
    Tuesday: boolean = false;
    Wednesday: boolean = false;
    Thursday: boolean = false;
    Friday: boolean = false;
    Saturday: boolean = false;

    constructor(initializer?: Partial<DaySelectionDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "DaySelectionDisplayItem";
}
